import { render, staticRenderFns } from "./m-click-tip.vue?vue&type=template&id=1787f446&"
import script from "./m-click-tip.vue?vue&type=script&lang=js&"
export * from "./m-click-tip.vue?vue&type=script&lang=js&"
import style0 from "./m-click-tip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports